import React from "react";
const LineSpacingIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "17", height: "15", viewBox: "0 0 17 15", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { fill: "currentColor" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M4.5 3L7 6H5v9h2l-2.5 3L2 15h2V6H2l2.5-3zM18 16v1H9v-1h9zm0-4v1H9v-1h9zm0-4v1H9V8h9zm0-4v1H9V4h9z",
    transform: "translate(-605.000000, -80.000000) translate(603.500000, 77.000000)"
  }
)))));
var LineSpacingIcon_default = LineSpacingIcon;
export {
  LineSpacingIcon_default as default
};
//# sourceMappingURL=LineSpacingIcon.js.map
